module.exports = __webpack_public_path__ + "img/logo-60x60.4535d47e.png";